import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Modal from 'react-bootstrap/Modal';
import InputAdornment from '@mui/material/InputAdornment';
import Collapse from 'react-bootstrap/Collapse';
import StepOne from '../../Assetes/Images/track-order/snerio1.png'
import StepTwo from '../../Assetes/Images/track-order/snerio2.png'
import StepThree from '../../Assetes/Images/track-order/snerio3.png'
import StepFour from '../../Assetes/Images/track-order/snerio4.png'
import StepFive from '../../Assetes/Images/track-order/snerio5.png'
import StepSix from '../../Assetes/Images/track-order/snerio6.png'
import PickStepOne from '../../Assetes/Images/track-order/snerio-1.png'
import PickStepTwo from '../../Assetes/Images/track-order/snerio-2.png'
import PickStepThree from '../../Assetes/Images/track-order/snerio-3.png'
import PickStepFour from '../../Assetes/Images/track-order/snerio-4.png'
import DeleveryIcon from '../../Assetes/Images/track-order/oure-for-delevery.svg'
import OrderHistoryDetail from './OrderDetail';
import jwt_decode from "jwt-decode";
import { trackOrder } from "../../Redux/actions/menu";
import { connect, useDispatch, useSelector, } from 'react-redux';
import { priceunit } from '../../Components/client-config';
import Header from '../../Components/Header';
import LastOrderDetail from './LastOrderDetail';
import { REMOVE_ORDER_DATA } from '../../Redux/actions/menuTypes';
import pickup from '../../Assetes/Images/pickup.png'
import { REMOVE_GUEST } from '../../Redux/actions/customerTypes';
import GoBack from '../BackButton/GoBack';
import domPurify from '../../Components/dompurify';
import { TRACK_ORDER_FEEDBACK_TITLE, TRACK_ORDER_TIME } from '../../constants';
import { useTranslation } from 'react-i18next';
import { checkPhone, MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';
import useCurrentLocale from '../../hooks/useLanguage';
import Footer from '../../Components/Footer';


function TrackOrder(props: any) {
  const dispatch = useDispatch();
  const orderData = useSelector((state: any) => state.menu.orderData);
  const lastOrderId = useSelector((state: any) => state.payment.order_id);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const isLogged = useSelector((state: any) => state.customer.isLogged);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [order_id, setOrder_id] = useState(lastOrderId)
  const [phone_number, setPhone_number] = useState('')
  const [phonError, setphonError] = useState(false)
  const [disable, setDisable] = useState(true)
  const [gesFeedback, setGesFeedback] = useState(false)
  const [gesLink, setGesLink] = useState("")
  const lang = useCurrentLocale();
  useEffect(() => {

    let token: any = localStorage.getItem("userToken") 
    let phone: any = sessionStorage.getItem("guestphone")

    if (order_id) {
      const data: any = {
        order_id: order_id,
        phone_number: null
      }
      if (token) {
        let decoded: any = jwt_decode(token);
        data.phone_number = decoded.customer.phone_number;
        setPhone_number(decoded?.customer?.phone_number?.split("-")[1])
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
          'event': 'trackOrder',
          'ecommerce': {
            'track': {
              'actionField': {
                'id': order_id,
                'phone': data.phone_number
              }
            }
          }
        })
        props.trackOrder(data);

      } else {
        if (phone) {
          data.phone_number = phone
          setPhone_number(phone?.split("-")[1])
          let windowObj = (window as any)
          windowObj.dataLayer.push({ ecommerce: null });
          windowObj.dataLayer.push({
            'event': 'trackOrder',
            'ecommerce': {
              'track': {
                'actionField': {
                  'id': order_id,
                  'phone': data.phone_number
                }
              }
            }
          })
          props.trackOrder(data,lang);
          setDisable(false)
        }
      }
    }
    else if (token) {
      const decoded: any = jwt_decode(token);
      const alreadyPhoneNo = decoded?.customer?.phone_number?.split("-")[1];
      if(alreadyPhoneNo)  setPhone_number(alreadyPhoneNo)
    }
  }, [])

  const handleCloseFeedback = () => setGesFeedback(false)

  const handlePhone = (e: any) => {
    const { value } = e.target;
    if (value.length <= NUMBERS_LIMIT) {
      setPhone_number(value);
    }
    if (!checkPhone(value)) return;
    if (value.length == NUMBERS_LIMIT) {
      setphonError(false);
    }
    if (value.length < NUMBERS_LIMIT) {
      setphonError(true);
    }
  };
  const handleOrderId = (e: any) => {
    setOrder_id(e.target.value);
    if (!e.target.value) setDisable(true)
    else setDisable(false)
  }

  const handleTrack = () => {
    let data = {
      phone_number: `${PHONE_CODE}-` + phone_number,
      order_id
    }
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'trackOrder',
      'ecommerce': {
        'track': {
          'actionField': {
            'id': order_id,
            'phone': data.phone_number
          }
        }
      }
    })
    props.trackOrder(data,lang)
  }



  useEffect(() => {
    let token: any = localStorage.getItem("userToken")
    let phone: any = sessionStorage.getItem("guestphone")
    if (!token && !phone) {
      dispatch({ type: REMOVE_ORDER_DATA })
    }
    return () => {
      if (!isLogged) {
        sessionStorage.removeItem("guestphone");
        sessionStorage.removeItem("guestName");
        dispatch({ type: REMOVE_ORDER_DATA })
        dispatch({ type: REMOVE_GUEST })
      }
    }
  }, [])

  const submitGesFeedback = () => {
    setGesFeedback(false)
    window.open(gesLink, "_blank")
  }

  useEffect(() => {
    if (isLogged) {
      setDisable(false);
    }
    if(orderData?.order_status_code == 4) {
      if(orderData?.ges_link && orderData?.ges_link != "") {
        setGesFeedback(true)
        setGesLink(orderData?.ges_link)
      }
    }
  },[orderData])
  const { t } = useTranslation();

  return (
    <><Header />
      <div className='container'>
        <div className='about-us track-order-content'>
          <div className='d-flex align-items-center gap-10 mb-3 web-backbtn web-backbtn-ar'>
            <GoBack />
            <h2 className='color-white font-bold mb-0'>{t("TRACK_ORDER")}</h2>
          </div>
        <div className="row">
          <div className='col-lg-6'>
            <div className="track-order w-100 mb-2">
              <div className="row">
                <div className="col-md-6 mt-1">
                  <TextField
                    value={phone_number}
                    onChange={handlePhone}
                    name="input1"
                    className='field-style contact-number-ar' type='text' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("PHONE_NUMBER")} ({MOBILE_STARS})</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error"
                    InputProps={{
                      startAdornment: <InputAdornment className='number-field ' position="start">{PHONE_CODE}</InputAdornment>,
                    }}
                    helperText={phonError ? `${t("PHONE_ERROR",{limit:NUMBERS_LIMIT})}` : ""}
                  />
                </div>
                <div className="col-md-6 mt-1">
                  <TextField
                    value={order_id}
                    onChange={handleOrderId}
                      className='field-style color-white contact-number-ar' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("ORDERID")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                </div>
                <Button onClick={handleTrack} disabled={(disable || phonError) ? true : false} 
                    className={` ${(disable || phonError) ? "disable-btn" : "able-btn"} w-50 m-auto d-flex mt-4`} variant="contained" color="error">{t("TRACK")}</Button>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            {
              orderData && <div className="track-order">
                  {/* <h3 className='track-title'>{t("TRACK_ORDER_PROGRESS")}</h3> */}
                  <h6 className='color-white'>{t("ORDER")}#{orderData?.order_id}</h6>
                {/* {
                  orderData?.delivery_status == "Pickup" ?
                    <img className='track-img'
                      src={orderData?.order_status_code == 1 ? PickStepOne
                        : orderData?.order_status_code == 2 ? PickStepTwo
                          : (orderData?.order_status_code == 12||orderData?.order_status_code == 3) ? PickStepThree
                            : orderData?.order_status_code == 11 ? PickStepFour
                              : (orderData?.order_status_code == 6 || orderData?.order_status_code == 7 || orderData?.order_status_code == 9 || orderData?.order_status_code == 8) ? StepSix : StepSix}
                      alt="Step" /> :
                    <img className='track-img'
                      src={orderData?.order_status_code == 1 ? StepOne
                        : orderData?.order_status_code == 2 ? StepTwo
                          : (orderData?.order_status_code == 12 || orderData?.order_status_code == 3) ? StepThree
                            : orderData?.order_status_code == 5 ? StepThree :
                              orderData?.order_status_code == 10 ? StepFour :
                                orderData?.order_status_code == 4 ? StepFive : StepSix
                                  // (orderData?.order_status_code == 6 || orderData?.order_status_code == 7 || orderData?.order_status_code == 9 || orderData?.order_status_code == 8) ? StepSix : StepSix
                          }
                      alt="Step" />
                } */}


                {/* {
                  orderData?.delivery_status == "Pickup" ?
                    <h2 className='order-steps'>{t("STEP")}
                      {
                        orderData?.order_status_code == 1 ? " 1" :
                          orderData?.order_status_code == 2 ? " 2" :
                            (orderData?.order_status_code == 12 || orderData?.order_status_code == 3) ? " 3" :
                              orderData?.order_status_code == 11 ? " 4" : ""
                      }
                    </h2> :
                    <h2 className='order-steps'>{t("STEP")}
                      {
                        orderData?.order_status_code == 1 ? " 1" :
                          orderData?.order_status_code == 2 ? " 2" :
                             (orderData?.order_status_code == 12 || orderData?.order_status_code == 3) ? " 3" :
                              orderData?.order_status_code == 5 ? " 3" :
                                orderData?.order_status_code == 10 ? " 4" :
                                  orderData?.order_status_code == 4 ? " 5" : ""
                      }
                    </h2>
                } */}
                 
                  {orderData?.delivery_status == "Pickup" ?
                    <img  width="25%" height="25%" src={pickup} alt="PickupIcon"  /> :
                    <img className='delevey-icon' src={DeleveryIcon} alt="DeleveryIcon" />
                  }

                  {orderData?.delivery_status == "Pickup" &&
                  <h4 className='out-delevery'>
                    {/* {orderData?.order_status_description} */}
                    {t("PICKUP_ORDER_READY")}
                  </h4>
                  }

                  {
                    (orderData.order_status_code == 6 ||  orderData.order_status_code == 7 || orderData.order_status_code == 8) &&
                    <div className='mb-2 color-white' style={{marginTop:"-15px"}}>{orderData.cancel_reason_description }</div>
                  }

                  {
                    orderData?.delivery_status != "Pickup" ?
                    <div className='flex justify-content-center gap-2 align-items-center mb-4 color-white'>
                      <h6 className='mb-0'>{t("EXPECTED_DELIVERY_TIME")}</h6>
                      <span>:</span>
                      <span>{orderData?.expected_delivery_time} {TRACK_ORDER_TIME}</span>
                    </div> : null
                  }
                  
                <h6 className='mb-0 color-white'>{t("ORDER_DETAILS")}</h6>

                <Button
                  onClick={() => setOpen(!open)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  className='show-dtail' color="error"><i className={!open ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line"}></i>
                </Button>

                <Collapse in={open}>
                  <div className='order-detail' id="example-fade-text">
                    <div className='border-box'></div>
                    <h5>{t("YOUR_ORDER")}</h5>
                    {orderData?.delivery_status == "Pickup" ? <h6>{t("PICKUP_FROM")}</h6> : <h6>{t("DELIVERY_TO")}</h6>}
                    {orderData?.delivery_status == "Pickup" ? <span>{orderData?.store_name}</span> : <span>{domPurify.sanitize(orderData?.delivery_address)}</span>}
                    {orderData?.delivery_status != "Pickup" && <h6>{t("DELIVERY_FROM")}</h6>}
                    {orderData?.delivery_status != "Pickup" && <span>{orderData?.store_name}</span>}


                    <div className='d-flex justify-content-between flex-wrap'>
                      <div className='order-contact'>
                        <span><i className="ri-phone-fill"></i></span>
                          <span className="track-order-detail-number">{orderData?.phone_number}</span>
                      </div>
                      
                    </div>

                    <div className="order-receipt">
                        <h6>{t("RECEIPT")}</h6>
                      <h6>{t("ORDER")}# {orderData?.order_id}</h6>
                    </div>
                    <LastOrderDetail orderData={orderData} />
                    <div className='order-added mt-3'>
                      <h6>{t("SUB_TOTAL")} :</h6>
                      <h5>{priceunit} {orderData?.order_netprice}</h5>
                    </div>

                    {orderData?.delivery_status == "Delivery" && <div className='order-added mt-3'>
                      <h6>{t("DELIVERY_FEE")} :</h6>
                      <h5>{priceunit}{orderData?.delivery_fee}</h5>
                    </div>
                    }

                    <div className='order-added mt-3'>
                        <h6>{t("GST")} ( {Math.round(orderData.tax_percent)} % ):</h6>
                        <h5>{priceunit} {Math.round(orderData?.tax_amount)}</h5>
                    </div>
                    <div className='order-added mt-3 mb-3'>
                      <h6>{t("TOTAL")} :</h6>
                      <h5>{priceunit} {orderData.order_grossprice}</h5>
                    </div>


                    <Modal show={show} onHide={handleClose} animation={false}>
                      <div className='modal-design'>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <Modal.Header className='border-0 p-0 history-btn' closeButton>

                      </Modal.Header>
                      <Modal.Body>
                        <OrderHistoryDetail orderData={orderData} />
                      </Modal.Body>
                    </Modal>
                  </div>
                </Collapse>
              </div>
            }
          </div>
        </div>
      </div>
      </div>
      <Footer />
      <Modal className='track-modal' show={gesFeedback} onHide={handleCloseFeedback} centered>
        <div className='modal-design'>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <Modal.Header className='justify-content-center'>
          <Modal.Title className='text-center'>{TRACK_ORDER_FEEDBACK_TITLE}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='w-100 delivery-order text-center'>
          <Button onClick={() => submitGesFeedback()} className='m-auto d-flex bg-theme mb-3' variant="contained" color="error">
          {t("FEEDBACK_FORM")}
          </Button>
        </Modal.Body>
      </Modal>
    </>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    trackOrder: function (data: any,locale:string) {
      dispatch(trackOrder(data,locale));
    }

  }
}
export default connect(null, mapDispatchToProps)(TrackOrder);